import { PARAMETRES_INTERNE_KEYS } from '@/store/modules/parametres-mutation-type';
import store from '@/store/store';

export default async function autoriseEcheanceNegativeVente() {
  await store.dispatch('parametres/loadParametresInterne', [PARAMETRES_INTERNE_KEYS.echeancesAFacturerNegativesAA.key]);
  const parametresInterne = store.getters['parametres/parametresInterne'];
  const societe = store.getters['societe/societeActive'];
  const isSupport = store.getters['user/isSupport'];
  const userId = store.getters['user/user']?.id;

  const isUserAllowed = isSupport || societe?.utilisateursEcheanceNegativeVente?.includes(userId);
  return parametresInterne(PARAMETRES_INTERNE_KEYS.echeancesAFacturerNegativesAA.key)
    && isUserAllowed;
}
